if (typeof CountdownTimerBanner === 'undefined') {
  class CountdownTimerBanner extends HTMLElement {
    constructor() {
      super();
      this.endDate = null;
      this.endTime = null;
      this.interval = null;
    }

    connectedCallback() {
      this.endDate = this.dataset.endDate;
      this.endTime = this.dataset.endTime || '23:59';
      
      // Only start countdown if we have a valid date
      if (this.endDate) {
        this.startCountdown();
      } else {
        console.warn('CountdownTimerBanner: Missing data-end-date attribute');
      }
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    startCountdown() {
      this.updateCountdown();
      this.interval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }

    updateCountdown() {
      const now = new Date();
      const endDateTime = this.getEndDateTime();
      const difference = endDateTime - now;

      if (difference <= 0) {
        this.displayExpired();
        if (this.interval) {
          clearInterval(this.interval);
        }
        return;
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      this.updateDisplay(days, hours, minutes, seconds);
    }

    getEndDateTime() {
      if (!this.endDate) {
        return new Date();
      }
      
      const [year, month, day] = this.endDate.split('-').map(Number);
      const timeParts = this.endTime ? this.endTime.split(':') : [];
      const hours = timeParts[0] !== undefined ? Number(timeParts[0]) : 23;
      const minutes = timeParts[1] !== undefined ? Number(timeParts[1]) : 59;
      return new Date(year, month - 1, day, hours, minutes, 59, 999);
    }

    updateDisplay(days, hours, minutes, seconds) {
      const daysEl = this.querySelector('[data-days]');
      const hoursEl = this.querySelector('[data-hours]');
      const minutesEl = this.querySelector('[data-minutes]');
      const secondsEl = this.querySelector('[data-seconds]');

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
    }

    displayExpired() {
      const daysEl = this.querySelector('[data-days]');
      const hoursEl = this.querySelector('[data-hours]');
      const minutesEl = this.querySelector('[data-minutes]');
      const secondsEl = this.querySelector('[data-seconds]');

      if (daysEl) daysEl.textContent = '00';
      if (hoursEl) hoursEl.textContent = '00';
      if (minutesEl) minutesEl.textContent = '00';
      if (secondsEl) secondsEl.textContent = '00';
    }
  }

  // Use a different name to avoid conflict with global.js CountdownTimer
  if (!customElements.get('countdown-timer-banner')) {
    customElements.define('countdown-timer-banner', CountdownTimerBanner);
  }


}